// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__UR-NO","actionsCol":"EnrolledClinics_actionsCol__1nPyD"};